import CandidateDetailsAccordion from "#candidate/components/candidate-details/CandidateDetailsAccordion"
import CandidateDetailsBody from "#candidate/components/candidate-details/CandidateDetailsBody"
import CandidateDetailsHead from "#candidate/components/candidate-details/CandidateDetailsHead"
import { useSetCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdGet } from "#candidate/services/api"
import { SkeletonSquare } from "#common/Skeleton"
import { DialogMaster } from "#core/components/dialog/Dialog"
import MainDetailsFooter from "#core/components/main-details/MainDetailsFooter"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { Box, Paper } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { useMemo } from "react"
import { useParams } from "react-router-dom"

function CandidateDetails({ candidateId }) {
	ChangeTitle("Candidato")
	const urlParams = useParams()
	const candidateIdParam = urlParams["candidateId"]
	const params = useMemo(
		() => ({ id: candidateId || candidateIdParam }),
		[candidateId, candidateIdParam]
	)
	const { reload } = useCandidateRedux()
	const { data, loading, error } = useApi(candidateIdGet, {
		params,
		autoFetch: true,
		reload,
	})
	useSetCandidate(data)

	if (loading) return <SkeletonSquare height="80vh" />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box component={Paper} display={"flex"} flexDirection={"column"} gap={0}>
			<CandidateDetailsHead />
			<CandidateDetailsBody />
			<CandidateDetailsAccordion />
			<MainDetailsFooter data={data} noUsePaper />
		</Box>
	)
}

export default CandidateDetails

export const CandidateDetailsDialog = ({ open, setOpen }) => {
	const { candidateId } = useCandidateRedux()
	return (
		<DialogMaster {...{ open, setOpen, maxWidth: "md" }}>
			<CandidateDetails candidateId={candidateId} />
		</DialogMaster>
	)
}
